import { useParams } from '@tanstack/react-router'

import type { CoverProduct, Enriched, EnrichedRangeData, SofaItem } from '@sofa-platform/types'

import { useRangeData } from './use-range-data'

type CurrentSofaData = {
  currentCoverProduct?: Enriched<CoverProduct>
  id: string
  rangeId: string
} & Enriched<SofaItem>

export function useCurrentSofa(): CurrentSofaData {
  const { id, rangeId } = useParams({ from: '/$country/$language/$mode/$rangeId/$id' })
  const { data: currentRangeData } = useRangeData(rangeId)
  const currentSofa = currentRangeData.sofas.find((sofa) => sofa.itemNo === id)
  if (!currentSofa) throw new Error(`Sofa with id: ${id} in ${rangeId} not found`)
  const currentCoverProduct = getCoverProductFromProduct(currentSofa.childItems, currentRangeData)
  return { ...currentSofa, currentCoverProduct, id, rangeId }
}

function getCoverProductFromProduct(childItems: string[] | undefined, rangeData: EnrichedRangeData) {
  if (!rangeData.coverProducts || !childItems) return
  return rangeData.coverProducts.find((item) => childItems.includes(item.itemNo))
}
